import { FC } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { HelpOutline as HelpIcon } from "@mui/icons-material";
import { useHelpContext } from "../../../context/help.context";

export type HelpIconProps = {
  screenId: string;
  fieldId?: string;
  tooltipText?: string;
  size?: "small" | "medium" | "large";
};

const HelpIconComponent: FC<HelpIconProps> = ({
  screenId,
  fieldId,
  tooltipText,
  size = "small",
}) => {
  const { showHelp, isHelpEnabled } = useHelpContext();

  if (!isHelpEnabled) return null;

  const handleClick = () => {
    showHelp(screenId, fieldId);
  };

  return (
    <Tooltip title={tooltipText || "Click for help"}>
      <IconButton
        size={size}
        onClick={handleClick}
        data-testid={`help-icon-${screenId}${fieldId ? `-${fieldId}` : ""}`}
        sx={{
          padding: 0.5,
          color: "primary.main",
          "&:hover": {
            color: "primary.dark",
          },
        }}
      >
        <HelpIcon fontSize={size} />
      </IconButton>
    </Tooltip>
  );
};

export default HelpIconComponent;
